/**
 * Does the signed-in person's organization send support reports to a monday
 * board? (GET /support/target — the server answers for the caller's OWN
 * organization and names no board.) Asked once per user and kept for ten
 * minutes, so opening Support never waits on it; a failed answer is not kept.
 */

import api from '@/services/api';

const REUSE_FOR_MS = 10 * 60 * 1000;

let cached: { userId: string; board: boolean; at: number } | null = null;
let inFlight: { userId: string; promise: Promise<boolean> } | null = null;

export function fetchSupportTarget(userId: string): Promise<boolean> {
  if (cached && cached.userId === userId && Date.now() - cached.at < REUSE_FOR_MS) {
    return Promise.resolve(cached.board);
  }
  if (inFlight && inFlight.userId === userId) return inFlight.promise;
  const promise = api.get('/support/target')
    .then(res => {
      const board = res.data?.board === true;
      cached = { userId, board, at: Date.now() };
      return board;
    })
    .catch(() => false)
    .finally(() => { if (inFlight?.promise === promise) inFlight = null; });
  inFlight = { userId, promise };
  return promise;
}
